import React from 'react';
import MobileRoutes from './MobileRoutes';
import LoadingOverlay from './components/layouts/LoadingOverlay';

function MobileApp() {
  return (
    <>
      <MobileRoutes />
      <LoadingOverlay />
    </>
  );
}

export default MobileApp;
